import { Button, Card, Col, Input, Row, Select } from 'antd';
import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import Item from '../../components/Form/Item';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { ParamsContext } from '../../routes/Context/ParamsContext';
import { SearchOutlined } from '@ant-design/icons';


const { Option } = Select;

const Filter = ({ columns, pathname, loading }) => {
  const history = useHistory();
  const params = useContext(ParamsContext);
  return (
    <Formik
      initialValues={{...params}}
      onSubmit={values => {
        let location = {
          pathname: pathname,
          search: queryString.stringify({
            ...params,
            ...values
          })
        };
        history.push(location);
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Card className="gx-card gx-p-15">
              <div className="gx-text-md gx-font-bold gx-mb-2">Filter</div>
              <Row gutter={15}>
                {columns.filter(el => el.filter && (el.visible === undefined || el.visible === true)).map((item, key) => {
                  return <Col md={6} xs={12} key={`filter-field-${key}`}>
                    <Item name={item.title} inline={false}>
                      {item.filterOptions ? (
                        <Select
                          defaultValue={formik.values[item.key]}
                          onChange={value => {
                            formik.setFieldValue(item.key, value);
                            if (item.onFilterChange) {
                              item.onFilterChange(value);
                            }
                          }}
                          showSearch
                          placeholder="Semua"
                          optionFilterProp="label"
                        >
                          {item.filterOptions.map((opt, idx) => {
                            return <Option value={opt.value} key={`filter-option-${idx}`} label={opt.label}>{opt.label}</Option>
                          })}
                        </Select>
                      ) : <Input defaultValue={formik.values[item.key]} name={item.key} onChange={formik.handleChange} autoFocus={key===0} />}
                    </Item>
                  </Col>;
                })}
              </Row>
              <Button type="default" htmlType="submit" loading={loading} icon={<SearchOutlined />} className="gx-mb-0">
                Tampilkan Hasil
              </Button>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Filter;